module.exports = __webpack_public_path__ + "img/114-09-plan.b7942e53.jpg";